import { render, staticRenderFns } from "./mGames.vue?vue&type=template&id=d2e98ca8&scoped=true"
import script from "./mGames.vue?vue&type=script&lang=js"
export * from "./mGames.vue?vue&type=script&lang=js"
import style0 from "./mGames.vue?vue&type=style&index=0&id=d2e98ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e98ca8",
  null
  
)

export default component.exports